import React from 'react';
import clsx from 'clsx';
import { ServiceDialog } from '../../styling/Styles'

const ExportProjectCodeViolationsPopUp = (props) => {

    const{
        open,
        setOpen,
        title
    }=props;

    const closePopUp = () => {
        setOpen(false);
    }

    return(
            <ServiceDialog
                open={open}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            > 
                 <div className={clsx('titlePopUp','paddingTitle')}> 
                    <span>{title}</span>
                    <div onClick={closePopUp} aria-hidden="true" className={clsx('pop-up-close-btn')}>x</div>
                </div>
                 <div className ='paddingTitle'>
                    
                    
                        <div className={clsx('spacingTopDiv')} style={{display: 'flex', justifyContent: 'center'}}>
                            { title === 'Empty page data model' &&
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                    <span style={{alignSelf:'center'}}>Data model of page is empty.</span>
                                    <span>You need to annotate at least one component in order to proceed.</span>
                                    <span>&nbsp;</span>
                                </div>
                            }
                            { title === 'Empty deploy configuration' &&
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                    <span style={{alignSelf:'center'}}>Deploy configuration is empty.</span>
                                    <span>You need to configure the deployment of the project in order to proceed.</span>
                                    <span>&nbsp;</span>
                                </div>
                            }
                            { title === 'Empty project pages' &&
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                    <span style={{alignSelf:'center'}}>There are no pages for this project.</span>
                                    <span>You need to create at least one page in order to proceed.</span>
                                    <span>&nbsp;</span>
                                </div>
                            }
                        </div>
                </div>

            </ServiceDialog>
    )

}

export default ExportProjectCodeViolationsPopUp;